import React from 'react';
import { Box } from '@mui/material';
import { COLORS } from '../styles/constants';

export const STATUS_CHIP_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px 10px',
  borderRadius: '999px',
  fontSize: '0.75rem',
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
  maxWidth: '100%',
} as const;

interface StatusChipProps {
  name: string;
  color: string | null;
}

export const StatusChip: React.FC<StatusChipProps> = ({ name, color }) => (
  <Box
    component='span'
    sx={{
      ...STATUS_CHIP_SX,
      backgroundColor: color || 'transparent',
      color: color ? COLORS.white : 'inherit',
    }}
  >
    <Box
      component='span'
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
      }}
    >
      {name}
    </Box>
  </Box>
);
